  // update product JSON every time products are loaded or changed
  document.addEventListener('rebuy.productsChange', (e) => {
    const widget = e.detail.widget;
    const storefrontHelper = new ShopifyStorefrontHelper;

    // loop over products in the widget and enrich product json
    widget.data.products.forEach((product) => storefrontHelper.updateProductJSON(product));
  });

